<template>
  <div class="all-product">
    <div class="focus-wrapper">
      <span class="focus-title"></span>
      <span class="focus-logo"></span>
      <Nav class="head-nav" :color="`${$isMobile ? '#ffffff' : '#fbf2dc'}`"></Nav>
    </div>
    <div class="product-list">
      <div class="container">
        <div class="product-groups" v-for="(item, index) in allProducts" :key="index">
          <div :class="`group-info ${item.products.length === 1 ? 'no-slide-info' : ''}`">
            <div class="group-til">
              <img :src="item.title_img" :alt="item.name">

            </div>

            <ul class="product-name-list">
              <li v-for="(ele, i) in item.products" :key="i" class="product-name">
                <span class="en-til">{{ ele.name.split("/")[0] }}</span>
                <span>/{{ ele.name.split("/")[1] }}</span>
              </li>
            </ul>
          </div>

          <div v-if="item.products.length > 2" class="out-swiper-wrapper">
            <div class="swiper product-swiper" :data-name="item.name">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(ele, i) in item.products" :key="i">
                  <div class="img-wraper">
                    <img :src="ele.pic" :alt="ele.name" width="100%">
                  </div>
                  <p class="product-name">
                    <span class="en-til">{{ ele.name.split("/")[0] }}</span>
                    <span>/{{ ele.name.split("/")[1] }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev" @click="prevSlide(item.name)"></div>
            <div class="swiper-button-next" @click="nextSlide(item.name)"></div>
          </div>

          <div v-else class="out-swiper-wrapper swiper">
            <div class="swiper-wrapper no-slide">
              <div class="swiper-slide" v-for="(ele, i) in item.products" :key="i">
                <div class="img-wraper">
                  <img :src="ele.pic" :alt="ele.name" width="100%">
                </div>
                <p class="product-name">
                  <span class="en-til">{{ ele.name.split("/")[0] }}</span>
                  <span>/{{ ele.name.split("/")[1] }}</span>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../components/Foot.vue";
import Nav from "../components/Nav.vue";
import Swiper from "swiper";
export default {
  components: {
    Foot,
    Nav
  },
  data() {
    return {
      swipersNameMap: {}
    }
  },
  computed: {
    allProducts() {
      return this.$globalData.all_products
    }
  },
  methods: {
    prevSlide(name) {
      this.swipersNameMap[name].slidePrev();
    },
    nextSlide(name) {
      this.swipersNameMap[name].slideNext();
    }
  },
  mounted() {
    const swipers = document.querySelectorAll('.product-swiper');
    swipers.forEach(swiperNode => {
      const name = swiperNode.attributes.['data-name'].value
      const swiper = new Swiper(swiperNode, {
        slidesPerView: 2,
        spaceBetween: this.$isMobile ? screen.width * 33 / 750 : 56,
        preventClicks: true,
        loop: true
      });
      this.swipersNameMap[name] = swiper
    });
  }
}
</script>
<style lang="less" scoped>
.all-product {
  .focus-title {
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/focus_logo_product.png) no-repeat top center;
    background-size: 100%;
  }
}

.focus-wrapper {
  height: 785px;
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/product_bg.jpg) no-repeat top center;
  background-size: cover;
  position: relative;

  .head-nav {
    position: absolute;
    left: 0;
    bottom: 53px;
  }
}

@media(max-width: 1200px) {
  .all-product {
    .head-nav {
      bottom: 1.333vw !important;
    }

    .product-list {
      padding: 0 !important;
    }

    .focus-wrapper {
      span.focus-title {
        background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/DC8D5AC4662143FF9280E345D276ADBF-6-2.png) no-repeat top center !important;
        background-size: 100% auto !important;
      }
    }

    .product-list {
      .container {
        width: 86.2667vw !important;
        padding-top: 2.933vw !important;
      }
    }


    .product-groups {
      height: auto !important;
      padding: 9.06667vw 13.6vw 0 13.6vw;
      box-sizing: border-box;

      .swiper-wrapper.no-slide {
        justify-content: center !important;
        width: 100% !important;
      }

      .group-info {
        display: flex;
        width: 100%;
        align-items: flex-end;
        margin-bottom: 6.4vw;
        &.no-slide-info{
          padding-left: 16vw !important;
        }
      }

      .group-til,
      .product-name-list,
      .out-swiper-wrapper {
        position: inherit !important;
        left: inherit !important;
        right: inherit !important;
        top: inherit !important;
        bottom: inherit !important;
        transform: scale(1) !important;
      }

      .group-til {
        width: 16.667vw !important;
        margin: 0 5.8667vw 0 0 !important;

        img {
          width: 100%;
          height: auto;
        }
      }

      .product-name-list {
        width: auto !important;
        flex-shrink: 0 !important;

        .product-name {
          font-size: 1.782667vw !important;
          line-height: 2.6667vw !important;
          text-align: left !important;
        }
      }

      .out-swiper-wrapper {
        width: 60vw !important;
        margin: 0 auto;

        .swiper {
          width: 60vw !important;
        }

        .swiper-button-prev {
          left: -13.6vw !important;
          transform: translate(0) !important;
        }

        .swiper-button-next {
          right: -13.6vw !important;
          transform: translate(0) rotate(180deg) !important;
        }

        .swiper-button-prev,
        .swiper-button-next {
          width: 7.6vw !important;
          height: 7.6vw !important;
          background-size: 100% auto !important;
          top: 9.86667vw !important;

        }

        .swiper-slide {
          width: 27.7333vw !important;
          text-align: center;

          .img-wraper {
            width: 27.7333vw !important;
            height: 27.7333vw !important;
            border-radius: 2.6667vw !important;

          }

          .product-name {
            font-size: 1.782667vw !important;
            line-height: 1.782667vw !important;
            margin-top: 2.6667vw !important;
          }
        }
      }
    }
  }
}

@media (max-width: 1716px) {
  .out-swiper-wrapper {
    right: calc(880px - 50vw) !important;
  }


}

@media (max-width: 1450px) {
  .product-groups {
    .group-til {
      transform: scale(0.9) !important;
    }

    .product-name-list {
      transform: scale(0.9) !important;
    }
  }
}

@media (max-width: 1400px) {
  .product-list {
    .container {
      width: 100% !important;
    }
  }
}

.product-list {
  background: #fbf2dc;
  padding: 0 0 140px 0;

  .container {
    width: 1400px;
    margin: 0 auto;

    .product-groups {
      height: 700px;
      width: 100%;
      border-bottom: 1px solid #110907;
      position: relative;

      .out-swiper-wrapper {
        position: absolute;
        width: 732px;
        right: 0;
        top: 184px;

        .swiper-button-prev,
        .swiper-button-next {
          position: absolute;
          width: 94px;
          height: 95px;
          background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/slide_btn.png") no-repeat top center;
          background-size: 100%;
          cursor: pointer;
          top: 120px;
        }

        .swiper-button-prev {
          left: -158px;
        }

        .swiper-button-next {
          right: -158px;
          transform: rotate(180deg);
        }
      }

      .swiper {
        width: 100%;
        overflow: hidden;

        .no-slide {
          justify-content: flex-end;
          width: 100% !important;
          gap: 56px;
        }

        .swiper-wrapper {
          display: flex;
          flex-wrap: nowrap;
          width: 33800px;

          .swiper-slide {
            width: 338px;
            text-align: center;
          }

          .img-wraper {
            width: 338px;
            height: 338px;
            overflow: hidden;
            border-radius: 22px;
          }
        }
      }

      .product-name {
        color: #524332;
        font-size: 21px;
        font-family: ming-min, ming;
        line-height: 32px;

        .en-til {

          font-family: en;
        }
      }

      .group-til {
        left: 0;
        top: 150px;
        position: absolute;
      }

      .product-name-list {
        list-style: none;
        margin: 0;
        padding: 0;
        position: absolute;
        width: 480px;
        left: 0;
        bottom: 100px;

        li {
          list-style: none;
          margin: 0;
          padding: 0;
          text-align: left;




        }
      }
    }
  }
}
</style>